import { TableNoLeftRightBorders } from 'components/base/layout-components';
import styled from 'styled-components';
import { lightColorPalette } from '@linearb/linui-common';
import { StyledEmptyStateAdjustFilters } from '../empty-state/EmptyStateAdjustFilters';
import { StyledTableHeaderRow } from 'components/base/Table/Table.styles';
import { STICKY_OFFSET } from 'components/base/common-styles';

export const StyledProgressionTable = styled.div`
  & ${TableNoLeftRightBorders} {
    margin-top: -4rem;
  }
  & ${StyledEmptyStateAdjustFilters} {
    margin-top: 2rem;
    padding-top: 2rem;
    border-top: 1px solid ${lightColorPalette.lbBlue_10};
  }
  & ${StyledTableHeaderRow} {
    top: calc(${props => props.offset}px - ${STICKY_OFFSET}rem) !important;
  }
`;
